import routerOptions0 from "D:/BaiduNetdiskDownload/Ccd/ccd-web-admin/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher_a67026a031e3754dda11d6a6568d367d/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}